import { MoreHorizontal } from 'lucide-react';
import { GRAPH_CARD_TITLE } from '@/constants/graphColumn';
import type { CoverageDimensionScore } from '@shared/domain/coverageDimensions';
import { computeMeanCoverageScore } from '@shared/domain/coverageScoring';
import { MiniCardHeader } from './MiniCardHeader';
import { MiniCardTitle } from './MiniCardTitle';
import { MiniCoverageDimensionSummary } from './MiniCoverageDimensionSummary';

interface MiniGraphCardProps {
  shortId: string;
  dimensions: CoverageDimensionScore[];
  meanScore?: number;
}

export function MiniGraphCard({ shortId, dimensions, meanScore }: MiniGraphCardProps) {
  const resolvedMeanScore = meanScore ?? computeMeanCoverageScore(dimensions);

  return (
    <div className="demo-graph-card flex flex-col gap-1.5 p-2 rounded-panel bg-surface-elevated">
      <MiniCardHeader
        shortId={shortId}
        trailing={<MoreHorizontal size={8} className="text-text-quaternary" />}
      />
      <MiniCardTitle>{GRAPH_CARD_TITLE}</MiniCardTitle>
      <MiniCoverageDimensionSummary dimensions={dimensions} meanScore={resolvedMeanScore} />
    </div>
  );
}
